<template>
  <div class="evaluate" style="width: 300px;max-width: 80%;height: auto;margin-top:50px">
    <br />
    <br />
    <div>
      <a-row type="flex" align="middle" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">工作是否完成:</a-col>
        <a-col :span="12" align="left">
          <a-radio-group v-model="effective" name="radioGroup">
            <a-radio value="true">完成</a-radio>
            <a-radio value="false">未完成</a-radio>
          </a-radio-group>
        </a-col>
      </a-row>
    </div>
    <div>
      <a-row type="flex" align="middle" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">订单完成度:</a-col>
        <a-col :span="12" align="left">
          <a-rate v-model="rate" allow-half />
        </a-col>
      </a-row>
    </div>
    <div>
      <a-row type="flex" align="middle" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">服务满意度:</a-col>
        <a-col :span="12" align="left">
          <a-rate v-model="serviceAttitude" allow-half />
        </a-col>
      </a-row>
    </div>
    <div>
      <a-row type="flex" align="middle" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">响应速度:</a-col>
        <a-col :span="12" align="left">
          <a-rate v-model="speciality" allow-half />
        </a-col>
      </a-row>
    </div>
    <div>
      <a-row type="flex" align="middle" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">服务能力:</a-col>
        <a-col :span="12" align="left">
          <a-rate v-model="timeliness" allow-half />
        </a-col>
      </a-row>
    </div>
    <div>
      <a-row type="flex" align="" justify="space-around">
        <a-col :span="12" align="left" style="font-weight:bold;">意见及建议:</a-col>
        <a-col :span="12" align="left">
          <a-textarea
            v-model="comments"
            placeholder="提出您的意见及建议"
            :autoSize="{ minRows: 2, maxRows: 10 }"
            :max-length="1024"
            style="width:150px;"
          />
        </a-col>
      </a-row>
    </div>
    <div>
      <a-button style="margin-top:10px" type="primary" @click="submitComments()">提交</a-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "evaluate",
  data() {
    return {
      effective: "true",
      rate: 0,
      serviceAttitude: 0,
      speciality: 0,
      timeliness: 0,
      comments: ""
    };
  },
  components: {},
  beforeMount() {},
  mounted() {},
  methods: {
    submitComments() {
      axios
        .get(
          "http://www.tcnanhua.com:5555/t-nh-comments/insertTNhComments?fbillno=" +
            this.$route.query.fbillno +
            "&effective=" +
            this.effective +
            "&rate=" +
            this.rate +
            "&comment=" +
            this.comments +
            "&serviceAttitude=" +
            this.serviceAttitude +
            "&speciality=" +
            this.speciality +
            "&timeliness=" +
            this.timeliness
        )
        .then(resp => {
          this.$message.success("提交成功,页面即将关闭,若未关闭请手动关闭");
          setTimeout(function() {
            window.opener = null;
            window.open("about:blank", "_top").close();
          }, 3000);
        });
    }
  }
};
</script>

<style scoped>
.evaluate {
  margin: 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Evaluate.vue